import {Model} from 'vue-mc';
import Vue from "vue";
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class jobActivityReportModel extends Model {

	defaults() {
		return {
			inBuiltApi: Vue.prototype.$interpretersApiUrl,
			methodTypes: 'paySlip',
			paySlipId: '',
			data: {},
			dbData: {
				fileRawData: ''
			}
		}
	}

	options() {
		return {
			methods: {
				paySlip: 'GET'
			}
		}
	}

	routes() {
		return {
			paySlip: 'interpreter/payment/{paySlipId}/pdf'
		}
	}

	requestRoute() {
		let headers = {
			Bearer: localStorage.getItem('jwt')
		};
		let method = this.getOption('methods.' + this.methodTypes);
		let route = this.inBuiltApi + this.getRoute(this.methodTypes);
		let params = this.getRouteParameters();
		let url = this.getURL(route, params);
		let data = this.data;
		let responseType = 'arraybuffer';

		// console.log(this.paySlipId, headers, method, url);

		return this.getRequest({headers, method, url, data, responseType}).send();
	}

	getPaySlip() {
		return this.requestRoute();
	}
}
